/**
 * Created by Administrator on 2017/7/2.
 */
export const LOADBLOGLIST = 'LoadBlogList';
export const SHOWBLOGLIST = 'ShowBlogList';
export const CHANGEPAGE = 'ChangePage';


// WEBPACK FOOTER //
// ./src/Component/BlogListTimeLine/actionTypes.js